import { useEffect, useState } from "react";

function useTailwindDarkMode() {
  const [isDark, setIsDark] = useState(false);

  useEffect(() => {
    const checkDark = () => {
      const root = document.documentElement;
      setIsDark(
        root.classList.contains('dark') ||
        root.getAttribute('data-theme') === 'dark'
      );
    };
    checkDark();

    // Optionally, listen for changes
    const observer = new MutationObserver(checkDark);
    observer.observe(document.documentElement, { attributes: true, attributeFilter: ['class', 'data-theme'] });

    return () => observer.disconnect();
  }, []);

  return isDark;
}

export default useTailwindDarkMode;
